'use strict';

export default function matchPath$config(options) {
    var fromPath = options.fromPath;
    var toPath = options.toPath;

    return function matchPath(value, vm) {
        var listenedVal = vm.path(toPath);

        if (!value || !listenedVal) return;

        var err = {
            type: options.type,
            level: options.level,
            message: options.message
        };

        vm.update(toPath, vm.path(toPath));
        var toPathErrors = vm.errorsFor(toPath) || [];
        var fromPathErrors = vm.errorsFor(fromPath) || [];

        var matchErrorIdx = -1;
        toPathErrors.forEach(function(error, idx) {
            if (['matchPath', 'match'].indexOf(error.type) > -1) {
                matchErrorIdx = idx;
            }
        });

        var noErrorForToPath = toPathErrors.length === 0 || toPathErrors[0].type === 'success';
        var noErrorForFromPath = fromPathErrors.length === 0 || fromPathErrors[0].type === 'success';

        if (value !== vm.path(toPath)) {

            // If success messages are attached, remove them
            [fromPath, toPath].forEach(function (path) {
                var errorsForPath = vm.errorsFor(path) || [];
                var successIdx = -1;
                errorsForPath.forEach(function (error, idx) {
                    if (error.type === 'success') {
                        successIdx = idx;
                    }
                });

                if (successIdx > -1) {
                    errorsForPath.splice(successIdx, 1);
                    vm.updateErrors(path, errorsForPath);
                }
            });

            if (matchErrorIdx === -1) {
                // if the error doesn't exist, push the error to the end
                toPathErrors.push(err);
            }

            vm.updateErrors(toPath, toPathErrors);
        } else if (noErrorForToPath && noErrorForFromPath) {
            // Add success message to both paths
            toPathErrors = [{type: 'success'}];
            vm.updateErrors(toPath, toPathErrors);
            return {type: 'success'};
        }
    };
}


/** WEBPACK FOOTER **
 ** ./src/validators/matchPath.js
 **/